import { type MouseEvent as ReactMouseEvent } from "react";

export const isEventInsideElement = (
  event: ReactMouseEvent<HTMLElement>,
  element: HTMLElement | null
): boolean => {
  const relatedTarget = event.relatedTarget;

  if (!(relatedTarget instanceof Node) || !element) {
    return false;
  }

  return element.contains(relatedTarget);
};
